export default __webpack_public_path__ + "static/media/dress5.906bb8e2.jpeg";